import {elementExists, isOldSafariVersion} from "../Utils";

/**
 * Controller for managing the error page.
 */
const ErrorPageController = {
    errorPageSelector: '.error-page-js',
    errorPageCubeSelector: '.error-page-cubes',

    /**
     * Initializes the error page controller.
     * Checks if the error page element exists and disables animations on older Safari versions.
     */
    init() {
        if (! elementExists(this.errorPageSelector)) return;
        this.disableAnimationInLowSafariVersions();
    },

    /**
     * Disables animations on the error page for older versions of Safari.
     * Targets the specific element with animation and sets its animation duration to zero.
     */
    disableAnimationInLowSafariVersions() {
        if (! isOldSafariVersion()) return;
        const elementWithAnimation = document.querySelector(this.errorPageCubeSelector);
        elementWithAnimation.style.setProperty('--animationDuration', '0s');
    }
}
export default ErrorPageController;